import type { SVGProps } from 'react';
const SvgPlaylistPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#playlist_play_svg__a)">
      <path
        fill="currentColor"
        d="M4 10h12v2H4v-2Zm0-4h12v2H4V6Zm0 8h8v2H4v-2Zm10 0v6l5-3-5-3Z"
      />
    </g>
    <defs>
      <clipPath id="playlist_play_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlaylistPlay;
